<template>
    <div>
        <div class="w-5/6 p-6 mb-3 ml-auto border shadow cursor-pointer my-message-bubble my-rounded md:w-3/4">
            <template v-if="sended || defaultData">
                <div class="flex items-center">
                    <i class="mr-3 text-2xl text-green-600 fas fa-check-circle"></i> 
                    <div>
                        <h1 class="text-lg font-bold">{{$t('form.tchat.fichier_envoye')}}</h1>
                        <a v-if="file && file.url" :href="file.url" target="_blank" class="block text-sm text-blue-500 hover:underline">
                            {{$t('form.tchat.consulter_le_fichier')}}
                        </a>
                    </div>
                </div>
            </template>
            <template v-else>
                <b>{{$t('form.tchat.envoyer_un_fichier')}}:</b>
                <sav-input v-model="file" type="file" />
                <button v-if="file" class="mt-3 px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" @click="end">
                    {{$t('form.tchat.envoyer')}} <i class="ml-1 fas fa-upload"></i>
                </button>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            defaultData: {
                type: Object
            }
        },
        data() {
            return {
                file: null,
                sended: false
            }
        },
        methods: {
            end() {
                if (this.file) {
                    this.sended = true
                    this.$emit('save-file', this.file)
                    this.$emit('click')
                }
            }
        },
        mounted() {
            if (this.defaultData) {
                this.file = this.defaultData
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/processes/cards/tchat/Components/FileMessageBubble.vue